import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import Components from './conponents'; // 根据自己需要添加相应的组件，减少main.js的工作量
// import vant from 'vant'
import './permission';
import 'amfe-flexible';
import './assets/reset.css';
import "@/assets/keyUp";
// 解决1px像素的问题
import './assets/border.css'
import utils from './utils/HTUtils'; //获取url参数
import VueCookies from 'vue-cookies';
Vue.prototype.$utils = utils; //注册全局方法
Vue.config.productionTip = false;
// 开启调试
Vue.config.devtools = true;
Vue.use(VueCookies);
Vue.use(Components);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')